import React from "react";
import PropTypes from "prop-types";
import useBelowBreakpoint from "core-web/hooks/useBelowBreakpoint";
import transformHeadingGroup from "theme/libs/wordpress/utils/transformHeadingGroup";
import ProductSlider from "theme/components/contentBlocks/ProductSlider";
import BleedWrapper from "theme/components/wrappers/BleedWrapper";

// Pure CMS data transformation before we send it to the "real" block!
const ProductSliderBlock = ({ content, isFirstModule, products, productsAmount }) => {
    const { heading: headingGroup, link } = content || {};
    const isMobile = useBelowBreakpoint("tabletLg");
    const device = isMobile ? "mobile" : "desktop";
    const { text: headingText, type: headingTag } = transformHeadingGroup(headingGroup, device);
    const { url, text: linkText } = link || {};

    return (
        <BleedWrapper>
            <ProductSlider
                products={products}
                productsAmount={productsAmount}
                headingText={headingText}
                headingTag={headingTag}
                url={url}
                linkText={linkText}
                shouldLazyLoad={!isFirstModule}
            />
        </BleedWrapper>
    );
};

ProductSliderBlock.propTypes = {
    content: PropTypes.shape({
        heading: PropTypes.shape({
            text: PropTypes.string,
            type: PropTypes.string,
        }),
        link: PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
        }),
    }).isRequired,
    isFirstModule: PropTypes.bool,
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    productsAmount: PropTypes.number.isRequired,
};

ProductSliderBlock.defaultProps = {
    isFirstModule: false,
};

export default ProductSliderBlock;
